const global = window

inputs.types.range = function (data, name, niceName, type, input, parent, inputWindow) {
    input.rangeslider();
    return data
}
